import React from 'react';
import { Box, Typography, useTheme, ButtonBase } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { getAddOnDetails } from 'common/modules/plans/add-ons/details';
import { getAddOnIcon } from 'common/modules/plans/add-ons/getAddOnIcon';
import { useTranslation } from 'services/localization';
import { AddOn, AddOnChannels, isAddOnInstalled } from 'common/modules/plans';
import * as ShopSelectors from 'selectors/ShopSelectors';
import * as ViewActions from 'actions/ViewActions';
import { useSelector } from 'react-redux';
import AddOnCardTag from './BlockCardTag';
import { useDispatch } from 'react-redux';

interface Props {
	addOn: AddOn;
}
const BlockCard = (props: Props) => {
	const { addOn } = props;
	const classes = useStyles();
	const { t } = useTranslation();
	const theme = useTheme();
	const dispatch = useDispatch();
	const shopFeatures = useSelector(ShopSelectors.shopFeatures);
	const isInstalled = isAddOnInstalled(addOn, shopFeatures);
	const addOnDetails = getAddOnDetails(addOn, t);

	return (
		<ButtonBase
			className={classes.root}
			onClick={() => dispatch(ViewActions.openAddOnModal(addOn, AddOnChannels.block_store))}
		>
			<Box className={classes.infoContainer}>
				<img
					className={classes.icon}
					src={getAddOnIcon(addOn) ?? undefined}
					alt={addOnDetails.name}
				/>
				<Box mt={2}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							marginBottom: theme.spacing(1),
						}}
					>
						<Typography className={classes.header} variant="h6">
							{addOnDetails.name}
						</Typography>

						{isInstalled && <AddOnCardTag />}
					</Box>
					<Typography variant="body2" color="textSecondary">
						{addOnDetails.subHeader}
					</Typography>
				</Box>
			</Box>
		</ButtonBase>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			borderRadius: '4px',
			border: `1px solid ${theme.palette.border.paper}`,
			backgroundColor: theme.palette.background.paper,
			padding: theme.spacing(4),
			'&:hover': {
				boxShadow: '0 1px 20px 0 rgba(0, 0, 0, 0.06)',
			},
			height: '100%',
			width: '100%',
			textAlign: 'left',
		},
		infoContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		header: {
			fontWeight: 500,
		},
		icon: {
			height: '50px',
			width: '50px',
			alignSelf: 'flex-start',
		},
	}),
);

export default BlockCard;
